import React, { useMemo } from 'react';

interface MonthPickerProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

const monthOptions = [
  { value: '01', label: 'January' },
  { value: '02', label: 'February' },
  { value: '03', label: 'March' },
  { value: '04', label: 'April' },
  { value: '05', label: 'May' },
  { value: '06', label: 'June' },
  { value: '07', label: 'July' },
  { value: '08', label: 'August' },
  { value: '09', label: 'September' },
  { value: '10', label: 'October' },
  { value: '11', label: 'November' },
  { value: '12', label: 'December' },
];

const parseMonthValue = (value: string) => {
  const match = /^(\d{4})-(\d{2})$/.exec(value);
  if (!match) {
    return { year: new Date().getFullYear().toString(), month: '01' };
  }

  return { year: match[1], month: match[2] };
};

const buildMonthValue = (year: string, month: string) => `${year}-${month}`;

const MonthPicker: React.FC<MonthPickerProps> = ({ id, label, value, onChange, className }) => {
  const { year, month } = parseMonthValue(value);
  const yearOptions = useMemo(() => {
    const selectedYear = Number(year);
    const currentYear = new Date().getFullYear();
    const minYear = Math.min(selectedYear, currentYear) - 5;
    const maxYear = Math.max(selectedYear, currentYear) + 5;

    return Array.from({ length: maxYear - minYear + 1 }, (_, index) => (minYear + index).toString());
  }, [year]);

  return (
    <div className={['month-picker', className].filter(Boolean).join(' ')}>
      <label className="month-picker-label" htmlFor={id}>
        {label}
      </label>
      <div className="month-picker-controls">
        <select
          className="form-control month-picker-select month-picker-month-select"
          id={id}
          onChange={event => onChange(buildMonthValue(year, event.target.value))}
          value={month}
        >
          {monthOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <select
          aria-label={`${label} year`}
          className="form-control month-picker-select month-picker-year-select"
          onChange={event => onChange(buildMonthValue(event.target.value, month))}
          value={year}
        >
          {yearOptions.map(optionYear => (
            <option key={optionYear} value={optionYear}>
              {optionYear}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default MonthPicker;
